import { NgComponentOutlet } from '@angular/common';
import { Component, HostListener, inject, input } from '@angular/core';
import { AlertService } from '@services/alert.service';
import { LoadingService } from '@services/loading.service';
import { SidePanelInstance, SidePanelService } from '@services/side-panel.service';

@Component({
  imports: [NgComponentOutlet],
  selector: 'app-side-panel-wrapper',
  styleUrl: './side-panel-wrapper.component.scss',
  templateUrl: './side-panel-wrapper.component.html',
})
export class SidePanelWrapperComponent {
  readonly sidePanel = input.required<SidePanelInstance>();
  private alert = inject(AlertService).get();
  private loading = inject(LoadingService).get();
  private sidePanelService = inject(SidePanelService);
  private sidePanels = this.sidePanelService.get();

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (!this.alert() && !this.loading() && this.sidePanels().at(-1)?.id === this.sidePanel().id) {
      this.close();
    }
  }

  protected close(): void {
    this.sidePanelService.close(this.sidePanel().id);
  }
}
